// @ts-ignore
import { selectPeopleOrdered } from 'services/people/selectors';
// @ts-ignore
import createDeepEqualSelector from '../../utils/reselect/createDeepEqualSelector';

const selectOptions = createDeepEqualSelector(
    selectPeopleOrdered,
    (orderedDataState: Record<string, any>) =>
        orderedDataState &&
        orderedDataState.map(({ id, fullName }: any) => ({
            key: id,
            text: fullName,
            value: id
        }))
);

export { selectOptions };
